<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">This book is dedicated to all the hardworking American pork producers. Our meat cases are full of perfect pork because of you. Thanks!</p>
<div class="image_wrap">
<p class="image"><a id="page_7"></a><img alt="image" class="horizontal" src="images/f0007-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04dedication.vue?7e37f4ee